import { LayoutDashboard, ListTodo, Settings } from "lucide-react";

export const NAVIGATION_ITEMS = [
  {
    title: "首页",
    url: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "待办",
    url: "/dashboard/todos",
    matchUrls: [
      "/dashboard/todos/new",
      "/dashboard/todos/edit",
      "/dashboard/todos/detail",
    ],
    icon: ListTodo,
  },
  {
    title: "设置",
    url: "/dashboard/settings",
    matchUrls: [
      "/dashboard/settings/user-profile",
      "/dashboard/settings/change-password",
    ],
    icon: Settings,
  },
];
